import {Dialog, DialogTitle, DialogContent, DialogActions, Button,Typography, DialogProps} from "@mui/material";
import {makeStyles} from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
	abandonUnsavedChangesDialog: {},
	actionBtn: {
		border: "none",
		color: theme.palette.primary.main,
		"&:hover": {
			color: theme.palette.primary.contrastText
		}
	}
}))

export interface IPropsComponentOverrides {
	content?: JSX.Element,
}

export interface IProps extends DialogProps {
	onConfirm:() => void,
	componentOverrides?: IPropsComponentOverrides
}

export const AbandonUnsavedChangesDialog = ({onConfirm, componentOverrides, className, ...baseProps}: IProps): JSX.Element => {
	const {cx, classes} = useStyles();

	return (
		<Dialog className={cx(classes.abandonUnsavedChangesDialog, className)} {...baseProps}>
			<DialogTitle><Typography variant="h6" component="p">Unsaved changes will be lost</Typography></DialogTitle>
			<DialogContent>
				{componentOverrides?.content ? componentOverrides.content : <Typography variant="body1">You&apos;ll lose any unsaved work if you exit now. Do you want to proceed?</Typography>}
			</DialogContent>
			<DialogActions>
				<Button variant="text" onClick={onConfirm} className={classes.actionBtn}>
					Exit
				</Button>
				<Button variant="text" onClick={(e) => baseProps?.onClose?.(e, "backdropClick")} className={classes.actionBtn}>
					Keep Editing
				</Button>
			</DialogActions>
		</Dialog>
	);
};

